import { C, G, SC } from "../styles/theme";

export function Th({ children }) {
  return <th style={{ padding: "10px 11px", textAlign: "left", fontSize: 11, fontWeight: 700, color: "#64748b", borderBottom: "1px solid #e2e8f0", background: "#f8fafc", whiteSpace: "nowrap", textTransform: "uppercase", letterSpacing: .3 }}>{children}</th>;
}

export function Td({ children, bold, blue, style: sx = {} }) {
  return <td style={{ padding: "9px 11px", fontSize: 13, borderBottom: "1px solid #f1f5f9", fontWeight: bold ? 700 : 400, color: blue ? C.blue : undefined, ...sx }}>{children}</td>;
}

export function ABt({ children, onClick, variant = "blue" }) {
  const sv = { blue: { bg: "#eff6ff", c: C.blue }, red: { bg: "#fef2f2", c: C.red }, green: { bg: "#f0fdf4", c: C.green }, amber: { bg: "#fefce8", c: C.amber }, orange: { bg: G.orange, c: "#fff" } }[variant] || { bg: "#eff6ff", c: C.blue };
  return <button onClick={onClick} style={{ background: sv.bg, color: sv.c, border: "none", padding: "5px 11px", borderRadius: 6, fontSize: 12, cursor: "pointer", fontWeight: 600, whiteSpace: "nowrap" }}>{children}</button>;
}

export { SC };
export const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

export const ADMIN_TABS = [
  { id: "dashboard", ic: "📊", lb: "Dashboard" }, { id: "analytics", ic: "📈", lb: "Analytics" },
  { id: "products", ic: "🔬", lb: "Products" }, { id: "orders", ic: "📦", lb: "Orders" },
  { id: "leads", ic: "📋", lb: "Leads" }, { id: "kanban", ic: "🗂️", lb: "Kanban" },
  { id: "jobs", ic: "💼", lb: "Jobs" }, { id: "blog", ic: "✍️", lb: "Blog" },
  { id: "testimonials", ic: "⭐", lb: "Testimonials" }, { id: "team", ic: "👥", lb: "Team" },
  { id: "certs", ic: "🏅", lb: "Certifications" }, { id: "images", ic: "🖼️", lb: "Images" },
  { id: "whatsapp", ic: "💬", lb: "WhatsApp" }, { id: "settings", ic: "⚙️", lb: "Settings" },
];

// tabs that own their own header controls instead of the shared search box
export const NO_SEARCH_TABS = ["dashboard", "analytics", "settings", "whatsapp", "images"];

export function filt(rows, keys, srch) {
  return !srch ? (rows || []) : (rows || []).filter(r => keys.some(k => String(r[k] || "").toLowerCase().includes(srch.toLowerCase())));
}

export function exportCSV(name, rows, cols, toast) {
  const csv = [cols.map(c => c[0]).join(","), ...rows.map(r => cols.map(([, k]) => '"' + (r[k] || "") + '"').join(","))].join("\n");
  const a = document.createElement("a");
  a.href = "data:text/csv;charset=utf-8," + encodeURIComponent(csv);
  a.download = name + ".csv"; a.click();
  toast("Exported " + name + ".csv");
}

export function genInvoice(o, settings, toast) {
  const s2 = settings || {};
  const gst = Math.round(o.amount * .18);
  const total = o.amount + gst;
  const lines = [
    "INVOICE",
    "=".repeat(44),
    s2.companyName || "Cyclojet Infotech Pvt. Ltd.",
    "GSTIN: " + (s2.gstin || "27AABCC1234F1Z5"),
    s2.address || "Bijnor | Delhi | Mumbai",
    "Phone: " + (s2.phone || "+91-7977779135"),
    "=".repeat(44),
    "Invoice No: " + o.id + "-INV",
    "Date: " + o.date,
    "-".repeat(44),
    "Bill To: " + o.customer,
    "Email: " + o.email,
    "-".repeat(44),
    "Product: " + o.product,
    "Quantity: " + o.qty,
    "Unit Price: Rs." + Math.round(o.amount / o.qty).toLocaleString(),
    "-".repeat(44),
    "Subtotal:  Rs." + o.amount.toLocaleString(),
    "GST @18%:  Rs." + gst.toLocaleString(),
    "TOTAL:     Rs." + total.toLocaleString(),
    "=".repeat(44),
    "Thank you for your business!",
  ].join("\n");
  const a = document.createElement("a");
  a.href = "data:text/plain;charset=utf-8," + encodeURIComponent(lines);
  a.download = "Invoice-" + o.id + ".txt"; a.click();
  toast("Invoice downloaded");
}
